// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { useLazyQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useLazyQueryInterop.ts';
import { expVal } from '@confluence/feature-experiments';
import { ADMINISTER, hasSpaceOperation } from '@confluence/space-utils/entry-points/graphql.ts';

import SpaceSideNavWebItemsQuery from './__generated__/SpaceSideNavWebItemsQuery.graphql.ts';
import type {
	SpaceSideNavWebItemsQueryVariables,
	SpaceSideNavWebItemsQuery as SpaceSideNavWebItemsQueryType,
} from './__types__/SpaceSideNavWebItemsQuery.ts';

export const useDoesTargetSpaceHaveDisabledBlogs = (): {
	getSpaceSidebarWebItems: any;
	spaceSidebarWebItemsLoading: boolean;
	spaceSidebarWebItemsError: ApolloErrorInterop | undefined;
	selectedSpaceHasBlogsToggledOff: boolean;
	isUserSpaceAdminOfTargetSpace: boolean;
} => {
	const [
		getSpaceSidebarWebItems,
		{
			data: spaceSidebarWebItemsData,
			loading: spaceSidebarWebItemsLoading,
			error: spaceSidebarWebItemsError,
		},
	] = useLazyQueryInterop<SpaceSideNavWebItemsQueryType, SpaceSideNavWebItemsQueryVariables>(
		SpaceSideNavWebItemsQuery,
		{
			fetchPolicy: 'network-only',
		},
	);

	const blogsWebItem = spaceSidebarWebItemsData?.spaceSidebarLinks?.main?.find(
		(item) => item?.webItemKey === 'spacebar-blogs',
	);

	// get if the space admin has hidden blogs manually or if we toggled off blogs by default
	const selectedSpaceHasBlogsToggledOff =
		(spaceSidebarWebItemsData && !blogsWebItem) || blogsWebItem?.hidden === true;

	const isUserSpaceAdminOfTargetSpace = expVal(
		'permissions_rbac_dependencies_callsites',
		'isEnabled',
		false,
	)
		? hasSpaceOperation(spaceSidebarWebItemsData?.space?.operations, ADMINISTER)
		: Boolean(spaceSidebarWebItemsData?.space?.currentUser?.isAdmin);

	return {
		getSpaceSidebarWebItems,
		spaceSidebarWebItemsLoading,
		spaceSidebarWebItemsError,
		selectedSpaceHasBlogsToggledOff,
		isUserSpaceAdminOfTargetSpace,
	};
};
